<template>
  <div class="Trainee-modal-overlay">
    <transition name="modal-expand">
      <div v-if="isVisible" class="Trainee-modal" @click.stop>
        <div class="modal-content">
          <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
          <div class="title-container">
            <h2>Task List for {{ $labels.project }}: {{ this.project.name }}</h2>
            <!-- <button v-if="tasks.length > 0" class="add-task-button" @click="exportToCSV">Export to CSV</button> -->
          </div>
          <div class="container-fluid-task">
            <vue-good-table :columns="columns" :rows="processedRows"
              :pagination-options="{ enabled: true, perPage: perPage }" :search-options="{ enabled: true }"
              :sort-options="{ enabled: true }">
              <template #table-row="props">
                <span v-if="props.column.field === 'chapter_name'">
                  {{ props.row.chapter_name }}
                </span>
                <span v-else :title="String(props.formattedRow[props.column.field] ?? '')">
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import axios from 'axios';
import { VueGoodTable } from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';

export default {
  name: 'ViewTaskListModal',
  components: {
    VueGoodTable,
  },
  props: {
    tasks: {
      type: Array,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      chapters: [],
      perPage: 10,
      isVisible: false,
      columns: [
        { label: 'ATA No', field: 'chapt_no', sortable: true, thClass: 'vgt-ata-column', tdClass: 'vgt-ata-column' },
        { label: 'Task No', field: 'task_no', sortable: true, thClass: 'vgt-task-no-column', tdClass: 'vgt-task-no-column' },
        { label: 'MT/AT', field: 'manob', sortable: true, thClass: 'vgt-manob-column', tdClass: 'vgt-manob-column' },
        { label: 'Scope', field: 'scope', sortable: true, thClass: 'vgt-task-no-column', tdClass: 'vgt-task-no-column' },
        { label: 'Description', field: 'description', sortable: true, thClass: 'vgt-description-column', tdClass: 'vgt-description-column' },
        { label: 'Reference', field: 'reference', sortable: true, thClass: 'vgt-reference-column', tdClass: 'vgt-reference-column' },
        // { label: 'Skill', field: 'skill', sortable: true, thClass: 'vgt-category-column', tdClass: 'vgt-category-column' },
        // { label: 'P1', field: 'P1', sortable: true, thClass: 'vgt-P1-column', tdClass: 'vgt-P1-column' },
        // { label: 'P2', field: 'P2', sortable: true, thClass: 'vgt-P1-column', tdClass: 'vgt-P1-column' },
        { label: 'Category', field: 'category', sortable: true, thClass: 'vgt-category-column', tdClass: 'vgt-category-column' },
      ],
    };
  },
  computed: {
    processedRows() {
      return this.sortedTasks;
    },
    sortedTasks() {
      return [...(this.tasks || [])].sort((a, b) => {
        const chapRegex = /^(\d+)([A-Za-z]*)$/;
        const [, numA, suffixA] = (a.chapt_no || '').match(chapRegex) || [];
        const [, numB, suffixB] = (b.chapt_no || '').match(chapRegex) || [];

        const chapterComparison = Number(numA) - Number(numB);
        if (chapterComparison !== 0) return chapterComparison;

        const suffixComparison = (suffixA || '').localeCompare(suffixB || '');
        if (suffixComparison !== 0) return suffixComparison;

        return parseInt(a.task_no, 10) - parseInt(b.task_no, 10);
      });
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    // exportToCSV() {
    //   const headers = ['Task No', 'ATA', 'M/O', 'Document', 'Operation', 'Type', 'Description', 'Subject'];
    //   const rows = this.tasks.map(task => [
    //     task.task_no,
    //     task.chapt_no,
    //     task.manob,
    //     task.document,
    //     task.operation,
    //     task.scope,
    //     task.description,
    //     task.subject,
    //   ]);
    //   let csvContent = 'data:text/csv;charset=utf-8,' + [headers, ...rows].map(e => e.join(",")).join("\n");

    //   const encodedUri = encodeURI(csvContent);
    //   const link = document.createElement("a");

    //   const now = new Date();
    //   const day = String(now.getDate()).padStart(2, '0');
    //   const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    //   const year = now.getFullYear();
    //   const hours = String(now.getHours()).padStart(2, '0');
    //   const minutes = String(now.getMinutes()).padStart(2, '0');
    //   const seconds = String(now.getSeconds()).padStart(2, '0');
    //   const dateTime = `${day}-${month}-${year}_${hours}${minutes}${seconds}`;

    //   const productName = this.selectedProduct.name.replace(/\s+/g, '-');

    //   const filename = `${productName}_task-list_${dateTime}.csv`;

    //   link.setAttribute("href", encodedUri);
    //   link.setAttribute("download", filename);
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // },
  },
  async mounted() {
    this.isVisible = true;
    this.fetchChapters();
    console.log('product', this.product);
    console.log('project', this.project);
  }
};
</script>

<style scoped>
.container-fluid-task {
  padding-top: 10px;
  width: 98%;
  margin-left: 1%;
  margin-right: 1%;
  display: flex;
  justify-content: center;
}

h1 {
  padding-top: 0px;
  padding-left: 3%;
}

.Trainee-modal-overlay {
  position: fixed;
  top: 0px;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 1000;
}

.Trainee-modal {
  background-color: #ffffff;
  overflow-y: auto;
  /* Enables vertical scrolling if needed */
  max-width: 90vw;
  max-height: 94vh;
  min-width: min(95vw, 2000px);
  padding: 10px;
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: 20px;
  z-index: 1002;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.modal-content {
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  padding: 15px;
  border: 1px solid #dddddd;
  border-radius: 3px;
}

.title-container {
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.container-fluid {
  padding-top: 5px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.modal-content h2 {
    margin-top: 0px;
    font-size: 30px;
    margin-left: 15px;
    margin-bottom: 10px;
}
</style>